// @ts-nocheck
import React, {Fragment, useEffect, useState, useCallback} from "react";
import {Emit_main} from "../navigation";
import {Eres_card, Eres_card_medium, Eres_iconbutton, Eres_spin_placeholder, Eres_warning_badge} from "../controls"
import * as C from "../controls"
import {audience_t} from "../resource/types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faPencil, faTrash, faFacebook, faLinkedin} from "@fortawesome/free-solid-svg-icons"
import {parse_object_in_list_of_str, gender_mapping, add_comma} from "../utils";
import * as P from "../program-state"
import {useParams, useNavigate} from "react-router-dom"
import { faLinkedinIn, faMeta, faTiktok, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import {z} from "zod";
import {useForm} from "react-hook-form";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";


const Meta_audience_detail = ({audience}: {audience: audience_t}) => {
    const locations = parse_object_in_list_of_str(audience.facebook__locations);
    const interests = parse_object_in_list_of_str(audience.facebook__interests);
    const behaviors = parse_object_in_list_of_str(audience.facebook__behaviors);
    const life_events = parse_object_in_list_of_str(audience.facenook__life_events);

    const is_audience_eligible = () => {
        return locations != null;
    }

    const eligible_display = () => {
        return (
            <div>
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Age group:</p>
                    <p className="tw-text-gray-900">{audience.age_from} - {audience.age_to}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Gender:</p>
                    <p className="tw-text-gray-900">{gender_mapping(audience.gender)}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Location:</p>
                    <div>{locations?.map((location) => <p className="tw-text-sm tw-text-gray-900" key={location.key}>{`${location.name}, ${location.region}, ${location.country_name}`}</p>)}</div>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Interest:</p>
                    <div>{interests?.map((interest) => <p className="tw-text-sm tw-text-gray-900" key={interest.id}>{interest.name}</p>)}</div>
                </div>
                {
                    behaviors && <div>
                        <hr className="tw-mt-2" />
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Behavior:</p>
                            <div>{behaviors?.map((behavior) => <p className="tw-text-sm tw-text-gray-900" key={behavior.id}>{behavior.name}</p>)}</div>
                        </div>
                    </div>
                }

                {
                    life_events && <div>
                        <hr className="tw-mt-2" />
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Life event:</p>
                            <div>{life_events?.map((life_event) => <p className="tw-text-sm tw-text-gray-900" key={life_event.id}>{life_event.name}</p>)}</div>
                        </div>
                    </div>
                }

                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-center tw-items-center">
                    { audience.estimated_facebook_reach?.users_lower_bound != null && 
                    <p className="tw-text-green-700 tw-text-center">
                        Estimated audience size: <span className="tw-text-green-800 tw-font-semibold">
                            {add_comma(audience.estimated_facebook_reach.users_lower_bound)}</span> -&gt; <span className="tw-text-green-800 tw-font-semibold">{add_comma(audience.estimated_facebook_reach.users_upper_bound)}</span>
                            </p>
                    }
                </div>
            </div>
        )
    }

    const non_eligible_display = () => (
        <Eres_warning_badge>You must choose a location to target facebook audience</Eres_warning_badge>
    )

    return (
        <Eres_card_medium>
            <div className="tw-p-4">
                <div className="tw-flex tw-items-center">
                    <FontAwesomeIcon icon={faMeta} aria-hidden="true"/>
                    <div className="tw-ms-2 tw-my-auto">
                        <h6 className="tw-mb-0 tw-font-semibold">Meta audience</h6>
                    </div>
                </div>
                <p className="tw-mt-4 tw-mb-4">Your audience on Meta</p>
                { is_audience_eligible() ? eligible_display() : non_eligible_display()}
            </div>
        </Eres_card_medium>
    )
}

const Linkedin_audience_detail = ({audience}: {audience: audience_t}) => {
    const locations = parse_object_in_list_of_str(audience.linkedin__locations);
    const interests = parse_object_in_list_of_str(audience.linkedin__interests);

    const is_audience_eligible = () => {
        return locations != null;
    }

    const eligible_display = () => {
        return (
            <div>
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Age group:</p>
                    <p className="tw-text-gray-900">{audience.age_from} - {audience.age_to}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Gender:</p>
                    <p className="tw-text-gray-900">{gender_mapping(audience.gender)}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Location:</p>
                    <div>{locations?.map((location, index) => <p className="tw-text-sm tw-text-gray-900" key={`location-${location.id || index}`}>{location.name}</p>)}</div>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Interest:</p>
                    <div>{interests?.map((interest) => <p className="tw-text-sm tw-text-gray-900" key={interest.urn}>{interest.name}</p>)}</div>
                </div>

                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-center tw-items-center">
                    {
                        audience.estimated_linkedin_reach?.total != null &&
                        <p className="tw-text-center tw-text-green-700">
                        Estimated audience size: <span className="tw-text-green-800 tw-font-semibold">{add_comma(audience.estimated_linkedin_reach.total)}</span>
                        </p>
                    }
                </div>
            </div>
        )
    }

    const non_eligible_display = () => (
        <Eres_warning_badge>You must choose a location to target linkedin audience</Eres_warning_badge>
    )

    return (
        <Eres_card_medium>
            <div className="tw-p-4">
                <div className="tw-flex tw-items-center">
                    <FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true"/>
                    <div className="tw-ms-2 tw-my-auto">
                        <h6 className="tw-mb-0 tw-font-semibold">Linkedin audience</h6>
                    </div>
                </div>
                <p className="tw-mt-4 tw-mb-4">Your audience on Linkedin</p>
                { is_audience_eligible() ? eligible_display() : non_eligible_display()}
            </div>
        </Eres_card_medium>
    )
}


const Tiktok_audience_detail = ({audience}: {audience: audience_t}) => {
    const locations = parse_object_in_list_of_str(audience.tiktok__locations);
    const interests = parse_object_in_list_of_str(audience.tiktok__interests);
    const actions = parse_object_in_list_of_str(audience.tiktok__action_categories);

    const is_audience_eligible = () => {
        return locations != null;
    }

    const eligible_display = () => {
        return (
            <div>
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Age group:</p>
                    <p className="tw-text-gray-900">{audience.age_from} - {audience.age_to}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Gender:</p>
                    <p className="tw-text-gray-900">{gender_mapping(audience.gender)}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Location:</p>
                    <div>{locations?.map((location, index) => <p className="tw-text-sm tw-text-gray-900" key={`location-${location.id || index}`}>{location.name}</p>)}</div>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Interest:</p>
                    <div>{interests?.map((interest) => <p className="tw-text-sm tw-text-gray-900" key={interest.interest_category_id}>{interest.interest_category_name}</p>)}</div>
                </div>

                {
                    actions && <div>
                        <hr className="tw-mt-2" />
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Life event:</p>
                            <div>{actions?.map((action) => <p className="tw-text-sm tw-text-gray-900" key={action.action_category_id}>{action.name}</p>)}</div>
                        </div>
                    </div>
                }

                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-center tw-items-center">
                    {
                        audience.estimated_tiktok_reach?.user_count != null &&
                        <p className="tw-text-center tw-text-green-700">
                        Estimated audience size: 
                        <span className="tw-text-green-800 tw-font-semibold">
                            {add_comma(audience.estimated_tiktok_reach.user_count?.lower_end)}
                            -&gt; <span className="tw-text-green-800 tw-font-semibold">{add_comma(audience.estimated_tiktok_reach.user_count?.upper_end)}</span>
                        </span>
                        </p>
                    }
                </div>
            </div>
        )
    }

    const non_eligible_display = () => (
        <Eres_warning_badge>You must choose a location to target tiktok audience</Eres_warning_badge>
    )

    return (
        <Eres_card_medium>
            <div className="tw-p-4">
                <div className="tw-flex tw-items-center">
                    <FontAwesomeIcon icon={faTiktok} aria-hidden="true"/>
                    <div className="tw-ms-2 tw-my-auto">
                        <h6 className="tw-mb-0 tw-font-semibold">Tiktok audience</h6>
                    </div>
                </div>
                <p className="tw-mt-4 tw-mb-4">Your audience on Tiktok</p>
                { is_audience_eligible() ? eligible_display() : non_eligible_display()}
            </div>
        </Eres_card_medium>
    )
}


const X_audience_detail = ({audience}: {audience: audience_t}) => {
    const locations = safeParseObjectList(audience.x__locations);
    const interests = safeParseObjectList(audience.x__interests);
    const keywords = audience.x__keywords;

    const is_audience_eligible = () => {
        return locations != null && locations.length > 0;
    }

    const eligible_display = () => {
        return (
            <div>
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Age group:</p>
                    <p className="tw-text-gray-900">{audience.age_from} - {audience.age_to}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Gender:</p>
                    <p className="tw-text-gray-900">{gender_mapping(audience.gender)}</p>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Location:</p>
                    <div>{locations?.map((location, index) => <p className="tw-text-sm tw-text-gray-900" key={`x-location-${location.id || location.targeting_value || index}`}>{location.name}</p>)}</div>
                </div>
                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                    <p className="tw-font-bold">Interest:</p>
                    <div>{interests?.map((interest, index) => <p className="tw-text-sm tw-text-gray-900" key={`x-interest-${interest.id || interest.targeting_value || index}`}>{interest.name}</p>)}</div>
                </div>

                {
                    keywords && keywords.length > 0 && <div>
                        <hr className="tw-mt-2" />
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Keywords:</p>
                            <div>{keywords?.map((keyword, index) => <p className="tw-text-sm tw-text-gray-900" key={`x-keyword-${index}`}>{keyword}</p>)}</div>
                        </div>
                    </div>
                }

                <hr className="tw-mt-2" />
                <div className="tw-mt-2 tw-flex tw-justify-center tw-items-center">
                    {
                        audience.estimated_x_reach?.user_count != null &&
                        <p className="tw-text-center tw-text-green-700">
                        Estimated audience size:
                        <span className="tw-text-green-800 tw-font-semibold">
                            {add_comma(audience.estimated_x_reach.user_count?.lower_end)}
                            -&gt; <span className="tw-text-green-800 tw-font-semibold">{add_comma(audience.estimated_x_reach.user_count?.upper_end)}</span>
                        </span>
                        </p>
                    }
                </div>
            </div>
        )
    }

    const non_eligible_display = () => (
        <Eres_warning_badge>You must choose a location to target X audience</Eres_warning_badge>
    )

    return (
        <Eres_card_medium>
            <div className="tw-p-4">
                <div className="tw-flex tw-items-center">
                    <FontAwesomeIcon icon={faXTwitter} aria-hidden="true"/>
                    <div className="tw-ms-2 tw-my-auto">
                        <h6 className="tw-mb-0 tw-font-semibold">X audience</h6>
                    </div>
                </div>
                <p className="tw-mt-4 tw-mb-4">Your audience on X</p>
                { is_audience_eligible() ? eligible_display() : non_eligible_display()}
            </div>
        </Eres_card_medium>
    )
}


export const Audience_widget_horizontal = ({audience_id} : {audience_id :  number | undefined}) => {
    const [saved_audiences, ps, cs] = P.use_saved_audiences()
    const [active_audience, set_active_audience] = useState<audience_t | null>(null);

    P.run_once_on_component_creation(() => void P.poll_saved_audiences(ps, cs))

    useEffect(() => {
        let found_audience = P.get_audience(saved_audiences, audience_id)
        set_active_audience(found_audience)
    }, [audience_id])

    return active_audience ? (
        <div className="tw-w-full tw-flex tw-flex-row tw-space-x-2 tw-p-2 tw-overflow-x-auto">
            <Meta_audience_detail audience={active_audience}/>
            <Linkedin_audience_detail audience={active_audience}/>
            <Tiktok_audience_detail audience={active_audience}/>
            <X_audience_detail audience={active_audience}/>
        </div>
    ) : <Eres_spin_placeholder />
}


interface Audience_edit_form {
    name: string;
    brand_id: number;
    age_from: number;
    age_to: number;
    gender: string;
    linkedin__locations: string[];
    facebook__locations: string[];
    tiktok__locations: string[];
    x__locations: string[];
    facebook__interests: string[];
    linkedin__interests: string[];
    tiktok__interests: string[];
    x__interests: string[];
    x__keywords: string[];
    include_custom_audience_ids: number[];
    exclude_custom_audience_ids: number[];
    facebook__behaviors: string[];
    facebook__life_events: string[];
    linkedin__seniorities: string[];
    linkedin__staff_counts: string[];
    linkedin__job_functions: string[];
    linkedin__job_industries: string[];
    linkedin__job_titles: string[];
    linkedin__growth_rates: string[];
    linkedin__company_revenues: string[];
    linkedin__member_traits: string[];
    tiktok__action_categories: string[];
}

const safeParseObjectList = (data: string[] | null | undefined): any[] => {
    if (!data || !Array.isArray(data)) return [];
    try {
        return parse_object_in_list_of_str(data);
    } catch (e) {
        console.warn('Failed to parse object list:', data, e);
        return [];
    }
}

interface LocationOption {
    key: string;
    display: string;
    platform: string;
    icon: IconDefinition;
}

interface InterestOption {
    key: string;
    display: string;
    source: 'Facebook' | 'TikTok' | 'LinkedIn';
    icon: IconDefinition;
}

const Edit_audience_form = ({audience, onSave, onCancel}: {
    audience: audience_t,
    onSave: (data: any) => Promise<void>,
    onCancel: () => void
}) => {
    const [brands, ps, cs] = P.use_brands()
    P.run_once_on_component_creation(() => void P.poll_connected_brands(ps, cs))
    
    // convert existing audience data to display format
    const existingLocations = React.useMemo(() => {
        const locations: LocationOption[] = [];
        
        // parse existing fb locations
        const fbLocations = safeParseObjectList(audience.facebook__locations);
        fbLocations.forEach((loc: any) => {
            if (loc && typeof loc === 'object') {
                locations.push({
                    key: `facebook-${loc.key || loc.id || Math.random().toString(36).substring(2, 11)}`,
                    display: loc.name || loc.display_name || loc.display || '',
                    platform: 'facebook',
                    icon: faMeta
                });
            }
        });
        
        // parse existing linkedin locations  
        const liLocations = safeParseObjectList(audience.linkedin__locations);
        liLocations.forEach((loc: any) => {
            if (loc && typeof loc === 'object') {
                locations.push({
                    key: `linkedin-${loc.key || loc.id || Math.random().toString(36).substring(2, 11)}`,
                    display: loc.name || loc.display || '',
                    platform: 'linkedin',
                    icon: faLinkedinIn
                });
            }
        });
        
        // parse existing tiktok locations
        const ttLocations = safeParseObjectList(audience.tiktok__locations);
        ttLocations.forEach((loc: any) => {
            if (loc && typeof loc === 'object') {
                locations.push({
                    key: `tiktok-${loc.key || loc.id || Math.random().toString(36).substring(2, 11)}`,
                    display: loc.name || loc.display || '',
                    platform: 'tiktok',
                    icon: faTiktok
                });
            }
        });

        // parse existing x locations
        const xLocations = safeParseObjectList(audience.x__locations);
        xLocations.forEach((loc: any) => {
            if (loc && typeof loc === 'object') {
                locations.push({
                    key: `x-${loc.id || loc.targeting_value || loc.key || Math.random().toString(36).substring(2, 11)}`,
                    display: loc.name || loc.display || '',
                    platform: 'x',
                    icon: faXTwitter
                });
            }
        });

        return locations;
    }, [audience]);

    const existingInterests = React.useMemo(() => {
        const interests: InterestOption[] = [];
        
        // parse existing fb interests
        const fbInterests = safeParseObjectList(audience.facebook__interests);
        fbInterests.forEach((int: any) => {
            if (int && typeof int === 'object') {
                interests.push({
                    key: `facebook-${int.key || int.id || Math.random().toString(36).substring(2, 11)}`,
                    display: int.name || int.display || '',
                    source: 'Facebook',
                    icon: faMeta
                });
            }
        });
        
        // parse existing linkedin interests
        const liInterests = safeParseObjectList(audience.linkedin__interests);
        liInterests.forEach((int: any) => {
            if (int && typeof int === 'object') {
                interests.push({
                    key: `linkedin-${int.key || int.urn || Math.random().toString(36).substring(2, 11)}`,
                    display: int.name || int.display || '',
                    source: 'LinkedIn',
                    icon: faLinkedinIn
                });
            }
        });
        
        // parse existing TikTok interests
        const ttInterests = safeParseObjectList(audience.tiktok__interests);
        ttInterests.forEach((int: any) => {
            if (int && typeof int === 'object') {
                interests.push({
                    key: `tiktok-${int.key || int.interest_category_id || Math.random().toString(36).substring(2, 11)}`,
                    display: int.name || int.interest_category_name || int.display || '',
                    source: 'TikTok',
                    icon: faTiktok
                });
            }
        });

        // parse existing X interests
        const xInterests = safeParseObjectList(audience.x__interests);
        xInterests.forEach((int: any) => {
            if (int && typeof int === 'object') {
                interests.push({
                    key: `x-${int.id || int.targeting_value || int.key || Math.random().toString(36).substring(2, 11)}`,
                    display: int.name || int.display || '',
                    source: 'X',
                    icon: faXTwitter
                });
            }
        });

        return interests;
    }, [audience]);

    const { register, handleSubmit, setValue, watch } = useForm<Audience_edit_form>({
        defaultValues: {
            name: audience.name || '',
            brand_id: audience.brand_id || 0,
            age_from: audience.age_from || 18,
            age_to: audience.age_to || 65,
            gender: audience.gender || '',
            linkedin__locations: safeParseObjectList(audience.linkedin__locations),
            facebook__locations: safeParseObjectList(audience.facebook__locations),
            tiktok__locations: safeParseObjectList(audience.tiktok__locations),
            x__locations: safeParseObjectList(audience.x__locations),
            facebook__interests: safeParseObjectList(audience.facebook__interests),
            linkedin__interests: safeParseObjectList(audience.linkedin__interests),
            tiktok__interests: safeParseObjectList(audience.tiktok__interests),
            x__interests: safeParseObjectList(audience.x__interests),
            x__keywords: audience.x__keywords || [],
            include_custom_audience_ids: audience.include_custom_audience_ids || [],
            exclude_custom_audience_ids: audience.exclude_custom_audience_ids || [],
            facebook__behaviors: safeParseObjectList(audience.facebook__behaviors),
            facebook__life_events: safeParseObjectList(audience.facenook__life_events),
            linkedin__seniorities: safeParseObjectList(audience.linkedin__seniorities),
            linkedin__staff_counts: safeParseObjectList(audience.linkedin__staff_counts),
            linkedin__job_functions: safeParseObjectList(audience.linkedin__job_functions),
            linkedin__job_industries: safeParseObjectList(audience.linkedin__job_industries),
            linkedin__job_titles: safeParseObjectList(audience.linkedin__job_titles),
            linkedin__growth_rates: safeParseObjectList(audience.linkedin__growth_rates),
            linkedin__company_revenues: safeParseObjectList(audience.linkedin__company_revenues),
            linkedin__member_traits: safeParseObjectList(audience.linkedin__member_traits),
            tiktok__action_categories: safeParseObjectList(audience.tiktok__action_categories),
        }
    })
    const watchedValues = watch()
    const [isSubmitting, setIsSubmitting] = useState(false);

    // location search state - initialize with existing locations
    const [locationOptions, setLocationOptions] = useState<LocationOption[]>(existingLocations);
    const [isLocationLoading, setIsLocationLoading] = useState(false);
    
    // interest search state - initialize with existing interests
    const [interestOptions, setInterestOptions] = useState<InterestOption[]>(existingInterests);
    const [isInterestLoading, setIsInterestLoading] = useState(false);

    const platformIcons = {
        facebook: faMeta,
        linkedin: faLinkedinIn,
        tiktok: faTiktok
    };

    const currentLocationSearchRef = React.useRef<string>('');
    const currentInterestSearchRef = React.useRef<string>('');

    const handleLocationSearch = useCallback(async (query: string) => {
        currentLocationSearchRef.current = query;
        
        if (query.length < 2) {
            if (query.length === 0) {
                setLocationOptions(existingLocations);
            }
            return;
        }

        setIsLocationLoading(true);
        
        try {
            const promises = [
                P.issue_json_get(P.v1api`audiences/search/facebook/location?query=${query}`, z.any(), cs.token),
                P.issue_json_get(P.v1api`audiences/search/linkedin/location?query=${query}`, z.any(), cs.token),
                P.issue_json_get(P.v1api`audiences/search/tiktok/location?query=${query}`, z.any(), cs.token)
            ];

            const results = await Promise.all(promises);
            let searchResults: LocationOption[] = [];

            results.forEach(([ok, data], index) => {
                if (ok && data) {
                    const platform = ['facebook', 'linkedin', 'tiktok'][index];
                    const platformResults = (Array.isArray(data) ? data : (data.hits || data.results || [])).map((item: any) => ({
                        key: `${platform}-${item.id || item.key}-${Math.random().toString(36).substring(2, 11)}`,
                        display: item.name || item.display_name || item.display || '',
                        platform: platform,
                        icon: platformIcons[platform as keyof typeof platformIcons]
                    }));
                    searchResults.push(...platformResults);
                }
            });

            if (currentLocationSearchRef.current === query) {
                // merge existing locations with search results, avoiding duplicates
                const combined = [...existingLocations];
                searchResults.forEach(result => {
                    if (!combined.some(existing => existing.display === result.display && existing.platform === result.platform)) {
                        combined.push(result);
                    }
                });
                setLocationOptions(combined);
            }
        } catch (error) {
            console.error('Location search error:', error);
        } finally {
            setIsLocationLoading(false);
        }
    }, [cs.token, existingLocations]);

    const handleInterestSearch = useCallback(async (query: string) => {
        currentInterestSearchRef.current = query;
        
        if (query.length < 2) {
            if (query.length === 0) {
                setInterestOptions(existingInterests);
            }
            return;
        }

        setIsInterestLoading(true);
        
        try {
            const promises = [
                P.issue_json_get(P.v1api`audiences/search/facebook/interest?query=${query}`, z.any(), cs.token),
                P.issue_json_get(P.v1api`audiences/search/linkedin/interest?query=${query}`, z.any(), cs.token),
                P.issue_json_get(P.v1api`audiences/search/tiktok/interest?query=${query}`, z.any(), cs.token)
            ];

            const results = await Promise.all(promises);
            let searchResults: InterestOption[] = [];

            results.forEach(([ok, data], index) => {
                if (ok && data) {
                    const platform = ['facebook', 'linkedin', 'tiktok'][index];
                    const platformResults = (Array.isArray(data) ? data : (data.hits || data.results || [])).map((item: any) => ({
                        key: `${platform}-${item.id || item.key}-${Math.random().toString(36).substring(2, 11)}`,
                        display: item.name || item.display_name || item.display || '',
                        source: platform === 'facebook' ? 'Facebook' : platform === 'linkedin' ? 'LinkedIn' : 'TikTok',
                        icon: platformIcons[platform as keyof typeof platformIcons]
                    })) as InterestOption[];
                    searchResults.push(...platformResults);
                }
            });

            if (currentInterestSearchRef.current === query) {
                // merge existing interests with search results, avoiding duplicates
                const combined = [...existingInterests];
                searchResults.forEach(result => {
                    if (!combined.some(existing => existing.display === result.display && existing.source === result.source)) {
                        combined.push(result);
                    }
                });
                setInterestOptions(combined);
            }
        } catch (error) {
            console.error('Interest search error:', error);
        } finally {
            setIsInterestLoading(false);
        }
    }, [cs.token, existingInterests]);

    const onSubmit = useCallback(async (data: Audience_edit_form) => {
        setIsSubmitting(true)
        try {
            // convert object arrays back to array of JSON strings for the API
            const convertToStringArray = (arr: any[]) => arr.map(item => JSON.stringify(item));
            
            const submitData = {
                ...data,
                linkedin__locations: convertToStringArray(data.linkedin__locations),
                facebook__locations: convertToStringArray(data.facebook__locations),
                tiktok__locations: convertToStringArray(data.tiktok__locations),
                x__locations: convertToStringArray(data.x__locations),
                facebook__interests: convertToStringArray(data.facebook__interests),
                linkedin__interests: convertToStringArray(data.linkedin__interests),
                tiktok__interests: convertToStringArray(data.tiktok__interests),
                x__interests: convertToStringArray(data.x__interests),
                facebook__behaviors: convertToStringArray(data.facebook__behaviors),
                facebook__life_events: convertToStringArray(data.facebook__life_events),
                linkedin__seniorities: convertToStringArray(data.linkedin__seniorities),
                linkedin__staff_counts: convertToStringArray(data.linkedin__staff_counts),
                linkedin__job_functions: convertToStringArray(data.linkedin__job_functions),
                linkedin__job_industries: convertToStringArray(data.linkedin__job_industries),
                linkedin__job_titles: convertToStringArray(data.linkedin__job_titles),
                linkedin__growth_rates: convertToStringArray(data.linkedin__growth_rates),
                linkedin__company_revenues: convertToStringArray(data.linkedin__company_revenues),
                linkedin__member_traits: convertToStringArray(data.linkedin__member_traits),
                tiktok__action_categories: convertToStringArray(data.tiktok__action_categories),
            }
            await onSave(submitData)
        } finally {
            setIsSubmitting(false)
        }
    }, [onSave])

    return (
        <Eres_card_medium>
            <div className="tw-p-6">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                        <C.Eres_form_label htmlFor="edit-name">Audience Name</C.Eres_form_label>
                        <C.Eres_line_edit
                            id="edit-name"
                            aria-label="audience name"
                            type="text"
                            {...register('name', { required: true })}
                        />
                        
                        <C.Eres_form_label htmlFor="edit-brand">Brand</C.Eres_form_label>
                        <C.Eres_combobox
                            id="edit-brand"
                            data={brands?.map(brand => ({key: brand.id.toString(), display: brand.name})) || []}
                            search_placeholder="Search for a brand..."
                            empty_selection_text="No brand selected"
                            unselect_placeholder="Select a brand"
                            no_matches_placeholder="No matching brands"
                            defaultValue={audience.brand_id ? audience.brand_id.toString() : undefined}
                            onChange={(selected) => selected && setValue('brand_id', parseInt(selected))}
                            onSearch={() => {}}
                        />

                        <C.Eres_form_label htmlFor="edit-age-from">Age From</C.Eres_form_label>
                        <C.Eres_line_edit
                            id="edit-age-from"
                            aria-label="age from"
                            type="text"
                            {...register('age_from', { required: true, valueAsNumber: true })}
                        />

                        <C.Eres_form_label htmlFor="edit-age-to">Age To</C.Eres_form_label>
                        <C.Eres_line_edit
                            id="edit-age-to"
                            aria-label="age to"
                            type="text"
                            {...register('age_to', { required: true, valueAsNumber: true })}
                        />

                        <C.Eres_form_label htmlFor="edit-gender">Gender</C.Eres_form_label>
                        <C.Eres_combobox
                            id="edit-gender"
                            data={[
                                {key: "0", display: "All"},
                                {key: "1", display: "Male"},
                                {key: "2", display: "Female"}
                            ]}
                            search_placeholder="Select gender..."
                            empty_selection_text="No gender selected"
                            unselect_placeholder="Select gender"
                            no_matches_placeholder="No matching genders"
                            defaultValue={audience.gender ? audience.gender.toString() : undefined}
                            onChange={(selected) => selected && setValue('gender', selected)}
                            onSearch={() => {}}
                        />

                        <C.Eres_form_label htmlFor="edit-location">Location</C.Eres_form_label>
                        <C.Eres_multiselect_combobox
                            id="edit-location"
                            data={locationOptions}
                            search_placeholder="Search for locations..."
                            empty_selection_text="No locations selected"
                            unselect_placeholder="Don't use location targeting"
                            no_matches_placeholder="No matching locations"
                            selectedOptions={(() => {
                                // build selected keys from current form state
                                const selectedKeys: string[] = [];
                                const fbLocs = watchedValues.facebook__locations || [];
                                const liLocs = watchedValues.linkedin__locations || [];
                                const ttLocs = watchedValues.tiktok__locations || [];
                                
                                // for each location in form state, find its display key
                                [...fbLocs, ...liLocs, ...ttLocs].forEach(loc => {
                                    const found = locationOptions.find(opt => 
                                        opt.display === (loc.name || loc.display || loc.display_name) &&
                                        opt.platform === (
                                            fbLocs.includes(loc) ? 'facebook' :
                                            liLocs.includes(loc) ? 'linkedin' : 'tiktok'
                                        )
                                    );
                                    if (found) {
                                        selectedKeys.push(found.key);
                                    }
                                });
                                
                                return selectedKeys;
                            })()}
                            onChange={(selected) => {
                                // split selected locations by platform and convert back to original format
                                const facebook: any[] = [];
                                const linkedin: any[] = [];
                                const tiktok: any[] = [];
                                
                                selected.forEach(key => {
                                    const option = locationOptions.find(opt => opt.key === key);
                                    if (option) {
                                        const originalData = {
                                            key: option.key.split('-').slice(1).join('-'),
                                            name: option.display,
                                            display: option.display
                                        };
                                        
                                        if (option.platform === 'facebook') {
                                            facebook.push(originalData);
                                        } else if (option.platform === 'linkedin') {
                                            linkedin.push(originalData);
                                        } else if (option.platform === 'tiktok') {
                                            tiktok.push(originalData);
                                        }
                                    }
                                });
                                
                                setValue('facebook__locations', facebook);
                                setValue('linkedin__locations', linkedin);
                                setValue('tiktok__locations', tiktok);
                            }}
                            onSearch={handleLocationSearch}
                            isLoading={isLocationLoading}
                        />

                        <C.Eres_form_label htmlFor="edit-interests">Interests</C.Eres_form_label>
                        <C.Eres_multiselect_combobox
                            id="edit-interests"
                            data={interestOptions}
                            search_placeholder="Search for interests..."
                            empty_selection_text="No interests selected"
                            unselect_placeholder="Don't use interest targeting"
                            no_matches_placeholder="No matching interests"
                            selectedOptions={(() => {
                                // build selected keys from current form state
                                const selectedKeys: string[] = [];
                                const fbInts = watchedValues.facebook__interests || [];
                                const liInts = watchedValues.linkedin__interests || [];
                                const ttInts = watchedValues.tiktok__interests || [];
                                
                                // for each interest in form state, find its display key
                                [...fbInts, ...liInts, ...ttInts].forEach(int => {
                                    const found = interestOptions.find(opt => 
                                        opt.display === (int.name || int.display || int.interest_category_name) &&
                                        opt.source === (
                                            fbInts.includes(int) ? 'Facebook' :
                                            liInts.includes(int) ? 'LinkedIn' : 'TikTok'
                                        )
                                    );
                                    if (found) {
                                        selectedKeys.push(found.key);
                                    }
                                });
                                
                                return selectedKeys;
                            })()}
                            onChange={(selected) => {
                                // split selected interests by platform and convert back to original format
                                const facebook: any[] = [];
                                const linkedin: any[] = [];
                                const tiktok: any[] = [];
                                
                                selected.forEach(key => {
                                    const option = interestOptions.find(opt => opt.key === key);
                                    if (option) {
                                        const originalData = {
                                            key: option.key.split('-').slice(1).join('-'),
                                            name: option.display,
                                            display: option.display
                                        };
                                        
                                        if (option.source === 'Facebook') {
                                            originalData.id = originalData.key;
                                            facebook.push(originalData);
                                        } else if (option.source === 'LinkedIn') {
                                            originalData.urn = originalData.key;
                                            linkedin.push(originalData);
                                        } else if (option.source === 'TikTok') {
                                            originalData.interest_category_id = originalData.key;
                                            originalData.interest_category_name = option.display;
                                            tiktok.push(originalData);
                                        }
                                    }
                                });
                                
                                setValue('facebook__interests', facebook);
                                setValue('linkedin__interests', linkedin);
                                setValue('tiktok__interests', tiktok);
                            }}
                            onSearch={handleInterestSearch}
                            isLoading={isInterestLoading}
                        />
                    </div>

                    <div className="tw-mt-6 tw-flex tw-gap-3">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-font-medium disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                        >
                            {isSubmitting ? 'Saving...' : 'Save Changes'}
                        </button>
                        <button
                            type="button"
                            onClick={onCancel}
                            className="tw-bg-gray-500 hover:tw-bg-gray-600 tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-font-medium"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Eres_card_medium>
    )
}

const Audience_detail = () => {
    const {audience_id} = useParams()
    const [saved_audiences, ps, cs] = P.use_saved_audiences()
    const [active_audience, set_active_audience] = useState<audience_t | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        set_active_audience(P.get_audience(saved_audiences, audience_id))
    }, [saved_audiences])

    const handleDeleteAudience = useCallback(async () => {
        if (!active_audience) return;
        
        if (!confirm(`Are you sure you want to delete the audience "${active_audience.name}"? This action cannot be undone.`)) {
            return
        }
        
        try {
            const [ok, resp] = await P.issue_json_delete(P.v1api`audiences/${active_audience.id}`, z.any(), cs.token)
            if (ok) {
                // force immediate refresh and wait for it to complete
                const writableCs = cs as any
                writableCs.saved_audiences = undefined
                writableCs.saved_audiences_last_update = 0
                await P.poll_saved_audiences(ps, cs)
                navigate('/audiences')
            } else {
                console.error('Delete audience failed:', resp)
                
                // try to extract error message 
                let errorMessage = 'Failed to delete audience. Please try again.'
                if (resp instanceof P.http_error) {
                    try {
                        const errorText = await resp.resp.text()
                        console.error('Backend error details:', errorText)
                        
                        // check for foreign key constraint violations
                        if (errorText.includes('foreign key constraint') || errorText.includes('still referenced')) {
                            errorMessage = `Cannot delete this audience because it is being used by one or more campaigns. Please delete the campaigns first, then try again.`
                        } else {
                            // try to parse as JSON for other errors
                            try {
                                const errorData = JSON.parse(errorText)
                                if (errorData.error && typeof errorData.error === 'string') {
                                    errorMessage = errorData.error
                                }
                            } catch (e) {
                                // if not JSON, use the raw text if it's helpful
                                if (errorText.length < 200 && errorText.length > 5) {
                                    errorMessage = errorText
                                }
                            }
                        }
                    } catch (e) {
                        console.error('Error reading delete response:', e)
                    }
                }
                
                alert(errorMessage)
            }
        } catch (error) {
            console.error('Error deleting audience:', error)
            alert('Failed to delete audience. Please try again.')
        }
    }, [active_audience, ps, cs, navigate])

    const handleSaveAudience = useCallback(async (updatedData: any) => {
        if (!active_audience) return;
        
        try {
            const [ok, resp] = await P.issue_json_put(P.v1api`audiences/${active_audience.id}`, updatedData, z.any(), cs.token)
            if (ok) {
                // force immediate refresh 
                const writableCs = cs as any
                writableCs.saved_audiences = undefined
                P.poll_saved_audiences(ps, cs)
                setIsEditMode(false)
                // update local state with new data
                set_active_audience({...active_audience, ...updatedData})
            } else {
                console.error('Update audience failed:', resp)
                let errorMessage = 'Failed to update audience. Please try again.'
                if (resp instanceof P.http_error) {
                    try {
                        const errorText = await resp.resp.text()
                        console.error('Backend error details:', errorText)
                        if (errorText.length < 200 && errorText.length > 5) {
                            errorMessage = errorText
                        }
                    } catch (e) {
                        console.error('Error reading update response:', e)
                    }
                }
                alert(errorMessage)
            }
        } catch (error) {
            console.error('Error updating audience:', error)
            alert('Failed to update audience. Please try again.')
        }
    }, [active_audience, ps, cs])

    const toggleEditMode = useCallback(() => {
        setIsEditMode(!isEditMode)
    }, [isEditMode])

    return (
        <>
          <Emit_main page_id="PAGE-audiences">
                <Fragment>
                {
                    active_audience ?
                    <Eres_card>
                        <div className="tw-mt-6 tw-px-6 tw-flex tw-flex-wrap">
                            <div className="tw-flex-grow">
                                <h3 className="tw-text-2xl tw-font-bold">Audience</h3>
                            </div>
                            <div className="tw-flex tw-flex-grow-0">
                                <Eres_iconbutton icon={faPencil} className="tw-me-1.5" onClick={toggleEditMode}>
                                    {isEditMode ? 'Cancel' : 'Edit'}
                                </Eres_iconbutton>
                                {!isEditMode && <Eres_iconbutton icon={faTrash} onClick={handleDeleteAudience}>Delete</Eres_iconbutton>}
                            </div>
                        </div>
                        <div className="tw-space-y-4 tw-p-2">
                            {isEditMode ? (
                                <Edit_audience_form 
                                    audience={active_audience} 
                                    onSave={handleSaveAudience}
                                    onCancel={toggleEditMode}
                                />
                            ) : (
                                <>
                                    <Meta_audience_detail audience={active_audience}/>
                                    <Linkedin_audience_detail audience={active_audience}/>
                                    <Tiktok_audience_detail audience={active_audience}/>
                                    <X_audience_detail audience={active_audience}/>
                                </>
                            )}
                        </div>
                    </Eres_card>
                    : <p>loading...</p>
                }
                </Fragment>
          </Emit_main>
        </>
    )
};


export default Audience_detail;
